export default "__VITE_ASSET__ComHLrxg__"